import { api } from "@/api";
import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { Rubro } from "@/shared/types/rubro";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface RubrosQuery extends BaseQuery {
    nombre?: string,
}

export async function getAllRubros(query?: RubrosQuery): Promise<QueryResponse<Rubro>> {
    await sleep(1000);
    const response = await api.get("rubros", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllRubrosQuery(query: RubrosQuery = {}, queryConfig: QueryConfig<QueryResponse<Rubro>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllRubros(query),
        queryKey: ["rubros", query],
    })
}

export interface GetAllRubroQueryProps {
    query: RubrosQuery,
    queryConfig?: QueryConfig<QueryResponse<Rubro>>,
    children: (queryResult: QueryResult<QueryResponse<Rubro>>) => ReactNode
}

export function GetAllRubrosQuery({
    query,
    queryConfig,
    children
}: GetAllRubroQueryProps) {
    const queryResult = useGetAllRubrosQuery(query, queryConfig);
    return children && children(queryResult);
}